<template>
	<div>
		<BaseAccordionCard :accordion_header="getStateWithParam('contact')">
			<template v-slot:component>
				<ContactBashkia class="accordion-card-middle" />
			</template>
		</BaseAccordionCard>

		<BaseAccordionController :accordion_header="getStateWithParam('label_info_adm')" :expand_accondion="true">
			<template v-slot:component>
				<div class="filter-indicator">
					<v-btn v-if="filteredlayer" @click="filteredlayer = null" class="grey--text text--darken-4" small>
						<div class="text-dart text-truncate mr-2">
							<span class="pt-1">{{ filteredlayer.properties.njesia }}</span>
						</div>
						<v-icon small>close</v-icon>
					</v-btn>
				</div>
				<MapController :mapoptions="mapoptions" :enableoptions="true" :optionsbottom="true" :hideoptionstoolbar="true" :hideoptions="hideoptions" :fitbounds="fitbounds" @update:zoom="handleZoomUpdate">
					<template v-for="(marker, markerind) in map_data.markers">
						<l-marker :key="'marker-' + markerind" :lat-lng="getMarkerCoordinates(marker.geometry.coordinates)" :icon="getIconForMarker(icon_url)" :visible="ismarkervisible">
							<l-popup>
								<div class="item item-divider">
									Njësia:
									<div>{{ marker.properties.emertim_ko }}</div>
								</div>
							</l-popup>
						</l-marker>
					</template>
					<template v-for="(layer, layerind) in njesitelayer">
						<l-polygon
							:key="'layer-' + layerind"
							:lat-lngs="getLayerCoordinates(layer.geometry.coordinates[0])"
							:options="{
								color: layer.properties.stroke,
								fillColor: layer.properties.fill,
								weight: layer.properties['stroke-width'],
							}"
						>
							<l-popup>
								<div class="item item-divider">
									<div>{{ layer.properties.njesia }}</div>
								</div>
								<div class="popup-line item item-icon-right">
									<span class="line-name mr-2">{{ getStateWithParam('adm_population_lab') }}: </span>
									<span class="line-value font-weight-bold">{{ layer.properties.Population }}</span>
								</div>
								<div class="popup-line item item-icon-right">
									<span class="line-name mr-2">{{ getStateWithParam('adm_buildings_lab') }}: </span>
									<span class="line-value font-weight-bold">{{ layer.properties.Buildings }}</span>
								</div>
								<div class="popup-line item item-icon-right">
									<span class="line-name mr-2">{{ getStateWithParam('adm_homes_lab') }}: </span>
									<span class="line-value font-weight-bold">{{ layer.properties.Dwellings }}</span>
								</div>
								<div class="popup-line item item-icon-right">
									<span class="line-name mr-2">{{ getStateWithParam('adm_address_lab') }}: </span>
									<span class="line-value font-weight-bold">{{ layer.properties.Adresa }}</span>
								</div>
								<div class="popup-line item item-icon-right">
									<span class="line-name mr-2">{{ getStateWithParam('adm_email_lab') }}: </span>
									<span class="line-value font-weight-bold"
										><a href="mailto:layer.properties.email">{{ layer.properties.email }}</a></span
									>
								</div>
								<div class="popup-line item item-icon-right">
									<span class="line-name mr-2">{{ getStateWithParam('adm_tel_lab') }}: </span>
									<span class="line-value font-weight-bold"
										><a href="tel:layer.properties.tel">{{ layer.properties.tel }}</a></span
									>
								</div>
								<div class="popup-line item item-icon-right" @click="filteredlayer = layer">
									<span class="line-name mr-2">{{ getStateWithParam('adm_view_villages') }}: </span>
									<v-icon class="line-icon">chevron_right</v-icon>
								</div>
							</l-popup>
						</l-polygon>
					</template>
					<template v-slot:options>
						<v-toolbar light flat color="white" class="options-toolbar">
							<v-toolbar-title>{{ getStateWithParam('adm_filter_lab') }}</v-toolbar-title>
							<v-btn icon class="grey--text text--darken-4" @click="hideoptions = !hideoptions">
								<v-icon>close</v-icon>
							</v-btn>
						</v-toolbar>
						<v-divider></v-divider>
						<v-list class="options-list-fullheight">
							<template v-for="(layer, layerind) in map_data.layers">
								<v-list-tile :key="'njesi-' + layerind" @click="filteredlayer = layer">
									<v-list-tile-content>
										<v-list-tile-title>{{ layer.properties.njesia }}</v-list-tile-title>
									</v-list-tile-content>
									<v-list-tile-action>
										<v-switch v-model="filteredlayer" :value="layer" class="option-switch justify-end"></v-switch>
									</v-list-tile-action>
								</v-list-tile>
								<v-divider :key="'layerdivider-' + layerind"></v-divider>
							</template>
						</v-list>
					</template>
				</MapController>
			</template>
		</BaseAccordionController>
	</div>
</template>

<script>
import MapController from '@/components/cards/MapController.vue';
import { LPolygon, LMarker, LPopup } from 'vue2-leaflet';
import ContactBashkia from '@/components/cards/ContactBashkiaCard.vue';
import info from '@/config/api/api_events/info.js';
import map_helper from '@/config/js_helper/map_helper.js';

export default {
	name: 'AdministrativeUnit',
	props: {},
	components: {
		ContactBashkia,
		MapController,
		LPolygon,
		LMarker,
		LPopup,
	},
	data() {
		return {
			mapoptions: {
				markerZoomAnimation: false,
			},
			zoom: 13,
			from_where: 7,
			map_data: {
				layers: [],
				markers: [],
				njesit: {},
			},
			icon_url: require('@/assets/img/new_icons/njesi_administrative.svg'),
			hideoptions: false,
			fitbounds: 0,
			filteredlayer: null,
		};
	},
	computed: {
		njesitelayer() {
			if (this.filteredlayer) {
				return [this.filteredlayer];
			} else {
				return this.map_data.layers;
			}
		},
		ismarkervisible() {
			return this.zoom > 11;
		},
		options() {
			return {
				onEachFeature: this.onEachFeatureFunction,
			};
		},
	},
	watch: {
		filteredlayer() {
			this.hideoptions = !this.hideoptions;
		},
		njesitelayer() {
			this.fitbounds++;
		},
	},
	created() {
		this.getNjesiteLayersFromCall();
	},
	methods: {
		getNjesiteLayersFromCall() {
			info.getNjesiteLayers()
				.then((response) => {
					this.map_data.layers = response.features;
					this.map_data.njesit = response.features.map((el) => {
						return { key: el.properties.njesia, val: el.properties.Adresa };
					});
				})
				.then(() => {
					this.$store.state.active_loader = false;
					this.getFshatratFromCall();
				})
				.catch((error) => {
					this.$store.state.active_loader = false;
					console.log(error, 'getNjesiteLayers');
				});
		},
		getFshatratFromCall() {
			info.getFshatrat()
				.then((response) => {
					this.map_data.markers = response.features;
				})
				.catch((error) => {
					console.log(error, 'getNjesiteLayers');
				});
		},
		getStateWithParam(param) {
			return this.$store.getters.getLanguageParameters(param);
		},
		handleZoomUpdate(newzoom) {
			this.zoom = newzoom;
		},
		styleFunction(index) {
			let styles = map_helper.getLineStrokeStyle(this.map_data.layers, this.from_where, index);
			return styles;
		},
		onEachFeatureFunction(feature, layer) {
			console.log(layer);
			return (feature, layer) => {
				layer.bindPopup(map_helper.makePopupSwitchIntoDataThatCome(layer, 2, this.map_data, this.from_where));
			};
		},
		getMarkerCoordinates(marker) {
			return [marker[1], marker[0]];
		},
		getLayerCoordinates(coordinates) {
			let newcoordinates = coordinates.map((coord) => {
				return [coord[1], coord[0]];
			});
			return newcoordinates;
		},
		getIconForMarker(url) {
			return map_helper.getIcon(url);
		},
	},
};
</script>

<style scope lang="scss" src="./AdministrativeUnit.scss"></style>
